import { Building } from "../../building/building.model";
import { Company } from "../../company/company.model";

export class ParkingReport {
  status: string;
  total: number;
}

export class RequestParameters {
  type?: string;
  dateFrom?: string;
  dateTo?: string;
  idBuilding?: number;
  idCompany?: number;
  // status?: string;
}

export class ParkingReportRequest {
  type?: string;
  dateFrom?: string;
  dateTo?: string;
  building?: Building;
  company?: Company;
  // status?: string;
}

export enum ParkingReportType{
  PARKING = "parking",
}